import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createObservabilitySlice } from './ObservabilitySlice/ObservabilitySlice';
import { ObservabilitySlice } from './ObservabilitySlice/ObservabilityTypes';

export const useObservabilityStore = create(
    devtools(
        immer<ObservabilitySlice>(
            (...a) => ({
                ...createObservabilitySlice(...a),
            })
        ),
    )
)
